/* eslint-disable import/prefer-default-export */
import { ReduxState } from '@batical/reducer/src/reducers'

export const selectMailProfile = (state: ReduxState) => state.mailProfile
